<script>
  // import { Image } from 'image-js';
  import { onMount } from 'svelte';
  import { exportType } from "store";
  import { Button, TextField, Card } from "smelte";
  import PhotoListItem from 'components/phototoolbox/PhotoListItem.svelte';
  import Exporter from 'components/exporter/Exporter.svelte';

  let photofiles = [];
  let amount = 0;
  let fileinput;
  let unitNumber = "PL1500";
  let regNumber, pvNumber = "";
  let unit = "EENHEID DEN HAAG";
  let district = "DISTRICT WESTLAND - DELFT";
  let department = "BASISTEAM RIJSWIJK";
  
  $: amount = photofiles.length;
  $: if (photofiles) {
    regeneratePhotonumbers();
    // console.log("photofiles changed", photofiles);
  };

  onMount(() => {
    exportType.set("photosheet");
  });
  
  function onFileSelected(e) {
    [].forEach.call(e.target.files, readImageFromFile);
  };
  
  function readImageFromFile(f) {
    let reader = new FileReader();
    reader.addEventListener("load", function() {
      let resultImage = resizeImage(this.result);
      photofiles = [...photofiles, {
        filename: f.name,
        size: f.size,
        photonumber: photofiles.length + 1,
        description: "",
        image: resultImage,
        lastPhoto: false
      }];
    }, false);
    reader.readAsDataURL(f);
  };

  // todo validation check move up if not index 0
  function handleMoveUp(event) {
    let imageId = event.detail.id;
    let tempPhotoFile = photofiles[imageId];
    photofiles.splice(imageId, 1);
    photofiles.splice(imageId-1, 0, tempPhotoFile);
    photofiles = photofiles;
  };

  // todo validation check move down if last photo in array
  function handleMoveDown(event) {
    let imageId = event.detail.id;
    let tempPhotoFile = photofiles[imageId];
    photofiles.splice(imageId, 1);
    photofiles.splice(imageId+1, 0, tempPhotoFile);
    photofiles = photofiles;
  };

  function handleMoveTo(event) {
    let imageId = event.detail.id;
    let toId = event.detail.toId-1;
    let tempPhotoFile = photofiles[imageId];
    photofiles.splice(imageId, 1);
    photofiles.splice(toId, 0, tempPhotoFile);
    photofiles = photofiles;
  };
  
  function handleRemoveImage(event) {
    let imageId = event.detail.id;
    photofiles.splice(imageId, 1);
    photofiles = photofiles;
  };

  function regeneratePhotonumbers() {
    photofiles.forEach((el, i) =>
    {
      el.photonumber = i + 1;
      el.lastPhoto = false;
      if (i == amount-1) { el.lastPhoto = true };
    });
  }

  // todo decide if resizing or not? bigger images is better quality
  function resizeImage(image) {
    // resize the image and double down on quality
    // convert to jpg?
    return image;
  };

  function generatePhotosheet() {
    console.log("generating...");
  };
</script>

<main>
  <div class="mx-2">  
    <h1 class="text-xl font-bold">
      Fotoblad generator
    </h1>

    <Card.Card
      hover=false
      elevation="2"
      classes="rounded inline-flex flex-col overflow-hidden m-2"
    >
      <div slot="title">
        <Card.Title
          title="Algemene info"
          subheader="Voeg foto's toe en genereer een fotoblad PDF"
        />
      </div>
      <div slot="text" class="p-5 pb-0 pt-3 text-gray-700 body-2">
        <TextField bind:value={unit} label="Eenheid" spellcheck="false" size=50 maxlength="40" name="unit" color="blue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
        <TextField bind:value={unitNumber} label="PL-code eenheid" spellcheck="false" size=50 maxlength="6" name="plcode" color="blue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
        <TextField bind:value={district} label="District" spellcheck="false" size=50 maxlength="60" name="district" color="blue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
        <TextField bind:value={department} label="Basisteam" spellcheck="false" size=50 maxlength="60" name="basisteam" color="blue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
        <TextField bind:value={regNumber} label="Registratie/BVH-nr" spellcheck="false" size=50 hint="bijv. 2023123456" maxlength="10" name="regNumber" persistentHint color="blue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
        <TextField bind:value={pvNumber} label="Behorend bij PV-nr" spellcheck="false" size=50 hint="bijv. 2 (als in 2023123456-2)" maxlength="3" name="pvNumber" persistentHint color="blue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
        Geselecteerde foto's ({amount})
      </div>
      <div slot="actions">
        <div class="p-2">
          <Button style="margin: 2px;" type="is-success is-light" on:click={fileinput.click()}>Selecteer afbeeldingen (jpg/png)</Button>
          <input
            style="display:none" 
            id="many"
            multiple
            type="file"
            accept=".jpg, .jpeg, .png"
            on:change={(e)=>onFileSelected(e)} bind:this={fileinput}
          />
          <Exporter info={{meta: {unit_number: unitNumber, reg_number: regNumber, pv_number: pvNumber, unit: unit.toUpperCase(), district: district.toUpperCase(), department: department.toUpperCase() }, images: photofiles}} buttonText="Genereer/download fotoblad" />
        </div>
      </div>
    </Card.Card>

    
    <div class="mb-2 flex w-full">

      
    </div>
        
    {#each photofiles as photoFile, i}
      <PhotoListItem photoFile={photoFile} photoId={i} on:removeImage={handleRemoveImage} on:moveUp={handleMoveUp} on:moveDown={handleMoveDown} on:moveTo={handleMoveTo} />
    {/each}

  </div>
</main>

<style>

</style>
